import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase'
import _ from 'underscore'
import moment from 'moment'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    appVersion: 1.57,
    browseFilters: { // no mutation
      search: "",
      tags: [],
      subjects: [],
      subscribedOnly: false,
    },

    //CURATION DATA
    lastEditQuestion: "",
    lastEditAnswer: "",
    contentProps: null,
    editors: null,
    admins: ["HSt6S2N9qHaG4sR2Uy6pYTMng123"],
    manageContentSearch: '', //no mutation
    manageContentSort: ['public','lectureDate'], //no mutation
    manageContentSortDesc: [true, false], //no mutation


    //CONTENT DATA
    availableDecksList: null,
    availableDecksObject: null,

    //USER SPECIFIC DATA
    userData: null,
    userPracticeHistory: null,
    userDailyProgress: null,

    //UI CONTROLS
    initialLoadComplete: false,
    globalLoading: false,
    snackbarMessage: {
      show: false,
      color: 'blue',
      message: 'Test message'
    },
    enableHotkeys: true
  },
  getters: {
    verifyAdmin: (state) => {
      if (state.admins == null) {
        return false
      }
      else {
        return state.admins.includes(firebase.auth().currentUser.uid)
      }
    },
    verifyEditor: (state) => {
      console.log(state.editors)
      if (state.editors == null) {
        return false
      }
      else {
        let ids = state.editors.map(x => x.id)
        return ids.includes(firebase.auth().currentUser.uid)
      }
    },

    tagsForBrowse: state => {
      let items = []
      state.availableDecksList.forEach(deck => {
        items.push(deck.tags)
      })
      items = items.flat()
      items = _.uniq(items)
      items = _.sortBy(items)
      return items
    },
    subjectsForBrowse: state => {
      let items = []
      state.availableDecksList.forEach(deck => {
        items.push(deck.subject)
      })
      items = _.uniq(items)
      items = _.sortBy(items)
      return items
    },
    decksForHome: state => {
      let items = []
      state.availableDecksList.forEach(deck => {
        if (state.userData.subscribedDecks.includes(deck.id)) {
          items.push(deck)
        }
      })
      items = _.uniq(items)
      items = _.sortBy(items, 'name')
      return items
    },
    subjectColor: (state, getters) => (subject) => {
      let i = getters.subjectsForBrowse.indexOf(subject)
      let colorArray = [
        'overline orange--text',
        'overline red--text',
        'overline green--text',
        'overline yellow--text',
        'overline grey--text',
        'overline grey--text',
        'overline grey--text',
        'overline grey--text',
        'overline grey--text',
        'overline grey--text',
        'overline grey--text',
        'overline grey--text',
        'overline grey--text',
        'overline grey--text',
      ]
      return colorArray[i]
    },
    homeDeckLastPracticed: (state, getters) => (id) => {
      if (id in state.userPracticeHistory) {
        let data = state.userPracticeHistory[id]

        if (data.currentSession != null) {
          return {text: "In Progress", color: "blue lighten-2", value: 10000}
        }
        else {
          let lastPractice = moment(data.lastClosedSession.toDate())
          let now = moment()
          let diff = now.diff(lastPractice, 'days')
          if (diff < 7) {
            return {text: diff +' d ago', color: "green lighten-2", value: diff}
          }
          else {
            return {text: diff +' d ago', color: "purple lighten-2", value: diff}
          }

        }
      }
      else {
        return {text: "Not Started", color: "orange lighten-1", value: 10001}
      }
    },
    homeDeckTimesPracticed: (state, getters) => (id) => {
      if (id in state.userPracticeHistory) {
        let data = state.userPracticeHistory[id]
        if ('history' in data) {
          return data.history.length
        }
        else {
          return 0
        }
      }
      else {
        return 0
      }
    },
    homeDeckLastAssessment: (state, getters) => (id) => {
      if (id in state.userPracticeHistory) {
        let data = state.userPracticeHistory[id]
        if ('history' in data) {
          if (data.history.length > 0) {
            return Math.round((data.history[data.history.length - 1].deckMetrics.assessScore) * 100)
          }
          else {
            return "-"
          }

        }
        else {
          return "-"
        }
      }
      else {
        return "-"
      }
    },




  },

  mutations: {
    contentPropsSet(state, val) {
      state.contentProps = val
    },
    editorsSet(state, val) {
      state.editors = val
    },
    adminsSet(state, val) {
      state.admins = val
    },
    //CURATION
    lastEditQuestionSet(state, val) {
      state.lastEditQuestion = val
    },
    lastEditAnswerSet(state, val) {
      state.lastEditAnswer = val
    },

    //CONTENT DATA
    availableDecksListSet(state, val) {
      state.availableDecksList = val
    },
    availableDecksObjectSet(state, val) {
      state.availableDecksObject = val
    },

    //USER SPECIFIC DATA
    userDataSet(state, val) {
      state.userData = val
    },
    userPracticeHistorySet(state, val) {
      state.userPracticeHistory = val
    },
    userDailyProgressSet(state, val) {
      state.userDailyProgress = val
    },

    //UI CONTROLS
    initialLoadCompleteSet(state, val) {
      state.initialLoadComplete = val
    },
    globalLoadingSet(state, val) {
      state.globalLoading = val
    },
    snackbarMessageSet(state, val) {
      state.snackbarMessage.show = true
      state.snackbarMessage.message = val.message
      state.snackbarMessage.color = val.color
    },
    enableHotkeysSet(state, val) {
      state.enableHotkeys = val
    },

  },
  actions: {
    contentPropsGet() {
      return firebase.firestore().collection('content').doc('config')
      .get().then(doc => {
        let data = doc.data()
        data.subjects = _.sortBy(data.subjects)
        data.tags = _.sortBy(data.tags)

        return store.commit('contentPropsSet', data)
      })
      .catch(err => {
        return store.commit('contentPropsSet', null)
      })
    },

    editorsGet() {
      let data = []
      //get list of editors
      return firebase.firestore().collection('adminAuth').doc('config')
      .get().then(doc => {
        return doc.data().editors
      }).then(editors => {

        //look up name of editor
        firebase.firestore().collection('users')
        .where(firebase.firestore.FieldPath.documentId(), 'in', editors)
        .get().then(snapshot => {
          snapshot.forEach(doc => {
            let result = doc.data()
            result.id = doc.id
            result['fullname'] = result.firstname + ' ' + result.lastname
            data.push(result)
          })
          return 'done'
        })
        return store.commit('editorsSet', data)
      })
      .catch(err => {
        return store.commit('editorsSet', null)
      })
    },

    //CONTENT DATA -- Called in App.vue in initializeData()
    availableDecksSubscribe() {

      //get list of editors
      return firebase.firestore().collection('deckPackages')
      .doc('browse')
      .onSnapshot(doc => {
        let availableDecksList = []
        let data = doc.data()
        for (let item in data) {
          availableDecksList.push(data[item])
        }
        store.commit('availableDecksListSet', availableDecksList)
        store.commit('availableDecksObjectSet', data)
        return "done"
      })
    },

    //USER SPECIFIC DATA -- Called in App.vue in initializeData()
    userDataSubscribe() {
      return firebase.firestore().collection('users')
      .doc(firebase.auth().currentUser.uid)
      .onSnapshot(doc => {
        return store.commit('userDataSet', doc.data())
      })
    },
    userPracticeHistoryGet() {
      return firebase.firestore().collection('learningRecord')
      .doc(firebase.auth().currentUser.uid)
      .collection('deckRecord').get()
      .then(snapshot => {
        let result = {}
        snapshot.forEach(doc => {
          result[doc.id] = doc.data()
        })
        store.commit('userPracticeHistorySet', result)
      })
    },
    //retrieve daily progress from userDailyActivity Table
    userDailyProgressGet() {
      return firebase.firestore().collection('userDailyActivity')
      .doc(firebase.auth().currentUser.uid)
      .get().then(doc => {
        if (doc.exists) {
          let data = doc.data()
          store.commit('userDailyProgressSet', data)
        }


      })
    }
  }
})



export default store
